import { render } from "./ProfileSection.vue?vue&type=template&id=3b7ec29b&scoped=true"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"

import "./ProfileSection.vue?vue&type=style&index=0&id=3b7ec29b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7ec29b"]])

export default __exports__